import { SET_CURRENT_SEARCHING_COLLECTION, SET_CURRENT_SEARCHING_TERM } from "../../types";

const INITIAL_STATE = {
    searching: '',
    searchTerm: '',
}

export default function search(state = INITIAL_STATE, action) {
    switch(action.type) {
        case SET_CURRENT_SEARCHING_COLLECTION:
            return {
                ...state,
                searching: action.searching
            }
        case SET_CURRENT_SEARCHING_TERM:
            return {
                ...state,
                searchTerm: action.searchTerm,
            }
        default:
            return state;
    }
}